import React, { useState } from 'react'
import * as preferences from '../../globals/tracking/preferences'
import get from 'lodash/get'
import { useHasMounted } from '../../helper/react-hooks'
// UI
import CMedia from 'lemon-campaign-ui/lib/molecules/Media'
import MediaCookieOverlay from '../cookies/mediaOverlay'

export default ({ component, defaults, imageMap, campaignId }) => {
  const placeholder = imageMap[component._id]
  const srcType = component.content.srcType

  if (srcType === 'video') {
    const [accepted, setAccepted] = useState(false)
    const hasMounted = useHasMounted()

    if (!hasMounted) {
      return null
    }

    const cookies = preferences.getPreferences(campaignId)
    const mediaCookieSet = get(cookies, 'Media', false)

    const handleAccept = () => {
      setAccepted(true)
    }

    if (!mediaCookieSet) {
      return <MediaCookieOverlay onAccept={handleAccept} />
    }
  }

  return (
    <CMedia
      {...defaults}
      fixedPlaceholder={true}
      size={component.content.size}
      src={component.content.src}
      placeholder={placeholder}
      video={component.content.video}
      controls={true}
      type={component.content.srcType}
      icon={component.content.icon}
      iconColor={component.content.iconColor}
      framed={component.content.framed}
      emoji={component.content.emoji}
      preventDesktopBehaviour={component.content.size === 'answer'}
    />
  )
}
